import React from 'react';
import PropTypes from 'prop-types';

import mergeClassName from 'merge-class-names';

import { createUseStyles } from '../../palette';
import decorate from '../../common/utils/decorate';

const useMainStyles = createUseStyles((theme) => ({
  '@keyframes loading-shimmer': {
    '0%': {
      transform: 'rotate(0deg)'
    },

    '100%': {
      transform: 'rotate(360deg)'
    }
  },

  loading: {
    display: 'inline-block',

    position: 'relative',
    width: 80,
    height: 80,

    '& > div': {
      animation: '$loading-shimmer 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite',

      display: 'block',
      boxSizing: 'border-box',
      margin: 8,
      borderWidth: 8,
      borderStyle: 'solid',
      borderColor: '#fff transparent transparent transparent',
      borderRadius: '50%',

      position: 'absolute',
      width: 64,
      height: 64
    },

    '& > div:nth-child(1)': {
      animationDelay: '-0.45s'
    },

    '& > div:nth-child(2)': {
      animationDelay: '-0.3s'
    },

    '& > div:nth-child(3)': {
      animationDelay: '-0.15s'
    }
  }
}));

const useVariantStyles = createUseStyles((theme) => ({}));

export default decorate(
  class extends React.PureComponent {
    static decorateWith = {
      classes: {
        main: useMainStyles,
        variant: useVariantStyles
      }
    };

    static propTypes = {
      variant: PropTypes.string
    };

    static defaultProps = {};

    constructor(props) {
      super(props);
    }

    componentDidMount() {}

    componentWillUnmount() {}

    componentDidUpdate(prevProps, prevState, snapshot) {}

    render() {
      const { classes, children, variant, ...props } = this.props;

      const mergedClassName = mergeClassName(
        classes.main.loading,
        variant && classes.variant[variant]
      );

      return (
        <div {...props} className={mergedClassName}>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      );
    }
  }
);
